module.exports = __webpack_public_path__ + "static/media/075-device.06833e9b.svg";